import { render, staticRenderFns } from "./HomesetAds.vue?vue&type=template&id=fe22ed56&"
import script from "./HomesetAds.vue?vue&type=script&lang=js&"
export * from "./HomesetAds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports